(function () {
  const SELECTOR = 'input.loyalty-checkbox[type="checkbox"], input.loyalty-checkbox';
  const APPEAR_TIMEOUT_MS = 20000;

  const MAX_RETRIES = 3;        // only re-apply a few times (prevents loops / 429s)
  const COOLDOWN_MS = 800;      // minimum time between re-applies
  const STOP_AFTER_MS = 12000;  // stop observing after 12s total

  let retries = 0;
  let lastApplyAt = 0;
  let stopped = false;

  function now() { return Date.now(); }

  function findBox() {
    return document.querySelector(SELECTOR);
  }

  function applyOnce(cb) {
    if (!cb || cb.disabled) return false;

    // If already checked, consider it done.
    if (!cb.checked) cb.checked = true;

    // Dispatch events ONCE per apply (some sites do cart calls here)
    cb.dispatchEvent(new Event('input', { bubbles: true }));
    cb.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function canApply() {
    return (now() - lastApplyAt) >= COOLDOWN_MS;
  }

  function stop(reason) {
    if (stopped) return;
    stopped = true;
    try { mo.disconnect(); } catch (_) {}
    try { clearInterval(poll); } catch (_) {}
    try { clearTimeout(hardStop); } catch (_) {}
    // console.debug('[loyalty] stopped:', reason);
  }

  // Stop if user actually interacts (don’t fight them)
  function userHandler(e) {
    if (!e.isTrusted) return;
    const t = e.target;
    if (t && t.matches && t.matches(SELECTOR)) stop('user interacted');
  }
  document.addEventListener('click', userHandler, true);
  document.addEventListener('change', userHandler, true);

  let mo = new MutationObserver(() => {
    if (stopped) return;
    const cb = findBox();
    if (!cb) return;

    // If framework flips it back to unchecked, re-apply with limits
    if (!cb.checked && retries < MAX_RETRIES && canApply()) {
      retries++;
      lastApplyAt = now();
      applyOnce(cb);
    }

    // If checked, and we've already successfully applied at least once,
    // don't keep observing forever — re-renders can spam mutations.
    if (cb.checked && retries === 0) {
      // first success; keep observing but only briefly (hardStop handles shutdown)
    }
  });

  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['checked', 'class', 'disabled', 'aria-checked']
  });

  // Poll for initial appearance
  const startAt = now();
  let poll = setInterval(() => {
    if (stopped) return;

    const cb = findBox();
    if (cb) {
      if (canApply()) {
        lastApplyAt = now();
        applyOnce(cb);
      }
      clearInterval(poll); // stop polling after first apply attempt
      return;
    }

    if ((now() - startAt) >= APPEAR_TIMEOUT_MS) {
      clearInterval(poll);
      console.warn(`Timed out: no checkbox found for selector: ${SELECTOR}`);
      stop('timeout waiting for checkbox');
    }
  }, 100);

  // Hard stop so we never run indefinitely
  const hardStop = setTimeout(() => stop('hard stop reached'), STOP_AFTER_MS);
})();